/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FleetStatisticsList
 */
export interface FleetStatisticsList {
    /**
     * 
     * @type {boolean}
     * @memberof FleetStatisticsList
     */
    vehicleManufacturer: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FleetStatisticsList
     */
    vehicleSerialNumber: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FleetStatisticsList
     */
    departmentLabel: boolean;
}

/**
 * Check if a given object implements the FleetStatisticsList interface.
 */
export function instanceOfFleetStatisticsList(value: object): value is FleetStatisticsList {
    if (!('vehicleManufacturer' in value) || value['vehicleManufacturer'] === undefined) return false;
    if (!('vehicleSerialNumber' in value) || value['vehicleSerialNumber'] === undefined) return false;
    if (!('departmentLabel' in value) || value['departmentLabel'] === undefined) return false;
    return true;
}

export function FleetStatisticsListFromJSON(json: any): FleetStatisticsList {
    return FleetStatisticsListFromJSONTyped(json, false);
}

export function FleetStatisticsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): FleetStatisticsList {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleManufacturer': json['vehicleManufacturer'],
        'vehicleSerialNumber': json['vehicleSerialNumber'],
        'departmentLabel': json['departmentLabel'],
    };
}

export function FleetStatisticsListToJSON(json: any): FleetStatisticsList {
    return FleetStatisticsListToJSONTyped(json, false);
}

export function FleetStatisticsListToJSONTyped(value?: FleetStatisticsList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleManufacturer': value['vehicleManufacturer'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'departmentLabel': value['departmentLabel'],
    };
}

